export default {
    chat: {
    // 標題
        title: '聊天',
        hiroTitle: 'Hiro',
        hiroSubtitle: '撰寫助手',
        figuresSubtitle: '附圖助手',
        analysisSubtitle: '分析助手',
        skillSubtitle: '技能助手',
        taskProcessing: '任務處理中',
        planDefaultTitle: '執行計畫',
        planStepFallback: '步驟 {index}',
        planTypes: {
            Free: '免費版',
            Internal: '內部版',
            Pro: 'Pro',
            Enterprise: '企業版',
        },

        // 歡迎頁面
        welcome: {
            title: '你好！我是 Hiro',
        },
        hiroIntro: '你的智能專利撰寫助手，專注於幫助你高效完成專利申請文件的撰寫和審查。',
        analysisIntro: '你的智能專利分析助手，專注於幫助你完成技術方案拆解、可專利性分析與方案補強。',
        disclaimer: 'AI生成僅供參考',
        messageResources: {
            template: '模板',
            figure: '附圖',
            priorArt: '現有技術',
            more: '另有 {count} 項：{names}',
        },
        readOnlyWarning: '權限不足：您只有唯讀權限',

        // 空狀態
        empty: {
            tryExamples: '快速開始 - 試試這些示例',
        },

        // 後端任務狀態
        taskStatus: {
            PENDING: '等待執行',
            STARTED: '執行中',
            SUCCESS: '執行成功',
            FAILURE: '執行失敗',
            RETRY: '重試中',
            REVOKED: '已取消',
            INTERRUPTED: '已中斷',
        },

        // 示例問題
        examples: [
            '幫我撰寫一份關於智能手機折疊屏技術的發明專利申請',
            '分析這份 OA 通知書中的審查意見',
            '優化權利要求書的撰寫，使其更加清晰和完整',
            '根據技術交底書生成說明書',
        ],

        // 附圖 Agent 歡迎頁
        figuresIntro: '你的附圖生成助手，可以根據專利文稿自動規劃和繪製專利附圖。',
        figuresExamples: [
            '根據已有材料資訊進行規劃附圖',
            '為權利要求中的主要技術特徵生成結構示意圖',
            '優化現有附圖，使其更符合專利規範',
            '根據技術交底書生成附圖清單',
        ],

        // Skill Agent 歡迎頁
        skillIntro: '你的技能倉庫助手，可以透過對話建立、編輯和管理 Skill Hub 上的技能包。',
        skillExamples: [
            '幫我建立一個「專利檢索策略」技能，根據技術方案規劃檢索式',
            '閱讀目前技能的 SKILL.md，優化描述與觸發說明',
            '為這個技能補充一個 scripts 目錄下的範例腳本',
            '檢查目前技能的檔案內容是否有安全風險',
        ],

        // 輸入框
        input: {
            placeholder: {
                default: '輸入消息... 使用 {\'@\'} 添加引用',
                disabled: '輸入已禁用，請稍候...',
                sending: '正在發送消息...',
            },
            placeholderDisabled: '請等待 Hiro 完成當前任務...',
            placeholderWaiting: '等待回覆中...',
            send: '發送',
            stop: '停止執行',
            waiting: '處理中',
            selectedText: '已選擇文本',
            clearSelection: '清除選擇',
            disabledFooter: 'Hiro 正在處理，請稍候...',
            keys: {
                instruct: '指令',
                generate: '生成',
                edit: '編輯',
                upload: '上傳',
                addFile: '新增檔案',
                referenceConversationFile: '引用對話中的檔案',
            },
            settings: { open: '更多設定' },
            references: {
                remove: '移除引用：{name}',
            },
            qaOnly: {
                label: '僅問答',
                description: '只在對話中回答，不寫入文件',
                tooltip: '僅在對話中回答，不會寫入文件',
                busy: '目前任務正在執行，暫時無法切換僅問答模式',
                updateFailed: '僅問答模式切換失敗，請重試',
                readOnly: '目前為唯讀專案，無法切換',
                executing: '目前任務正在執行，無法切換',
                updating: '正在更新僅問答狀態',
                permissionLoading: '正在確認專案權限',
                disabled: '目前暫時無法切換',
                remove: '關閉僅問答',
                writeBlockedTitle: '文件寫入已阻止',
                writeBlockedMessage: '目前已開啟「僅問答」，本次文件寫入已被阻止。請選擇如何處理。',
                writeBlockedQuestion: '如何處理本次被阻止的文件寫入？',
                keepEnabled: '保持僅問答',
                keepEnabledDescription: '維持僅問答狀態，不寫入文件。',
                disableAndContinue: '關閉並繼續寫入',
                disableAndContinueDescription: '關閉僅問答，並自動繼續剛才被阻止的寫入。',
                writeBlockedRetryMessage: '已關閉僅問答，請繼續執行剛才被阻止的文件寫入。',
            },
            mode: {
                label: '模式',
                description: '選擇目前對話的生成方式',
            },
            workMode: {
                agent: '智能體',
                copilot: '助手',
            },
            upgrade: '升級',
        },

        // 文件上傳
        upload: {
            filePromptSuffix: '閱讀這些文件，總結其中內容對當前任務的影響，生成下一步建議。',
        },

        // 對話歷史
        history: {
            title: '對話歷史',
            empty: '暫無對話歷史',
            search: '搜索對話',
            rename: '重命名',
            delete: '刪除',
            defaultTitle: '新對話',
            deleteConfirm: '確認刪除此對話嗎？',
            inputErrorMessage: '請輸入對話標題',
            renameSuccess: '重命名成功',
            // 日期分組標籤
            today: '今天',
            yesterday: '昨天',
            lastWeek: '最近一週',
            lastMonth: '最近一個月',
            older: '更早',
        },

        // 操作按鈕
        actions: {
            copy: '複製',
            copySuccess: '已複製到剪貼板',
            copyFailed: '複製失敗',
            mergeToDocument: '合併到文檔',
            mergeToDocumentTooltip: '將此內容合併寫入當前文檔',
            newChat: '新對話',
            selectLanguage: '設置AI輸出語言',
            languageLabel: '模型輸出語言',
            expandFullContent: '展開查看完整內容',
        },

        newChatConfirm: {
            message: 'Hiro將開啟一個新對話，並將目前對話歷史保存在Chat History中。',
        },

        // 任務未完成提醒
        incompleteTasksDialog: {
            title: '任務尚未完成',
            description: '當前任務計劃中還有未完成的步驟：',
            bannerText: '任務已暫停，仍有未完成步驟',
            completedLabel: '已完成',
            incompleteLabel: '未完成',
            continueBtn: '繼續執行任務',
            endBtn: '結束任務',
            continueMessage: '請繼續執行剩餘的任務步驟',
            endMessage: '將所有任務計劃步驟標記為已完成，然後結束任務。',
            inputPlaceholder: '補充說明（可選）',
        },

        // 消息
        messages: {
            sendFailed: '發送消息失敗，請重試',
            connecting: '正在連接聊天...',
            applyingTemplate: '正在應用模板...',
            templateAppliedSuccess: '已成功應用模板：{name}',
            templateApplyFailed: '應用模板失敗，請重試',
            editorNotInitialized: '編輯器未初始化，無法應用模板',
            loadHistoryFailed: '載入對話歷史失敗',
            createFailed: '創建對話失敗',
            deleteFailed: '刪除對話失敗',
            renameFailed: '重命名對話失敗',
            permissionDenied: '您當前沒有使用 {agentName} 的權限，請聯繫銷售升級套餐。',
            permissionDeniedOverseas: '您當前沒有使用 {agentName} 的權限，請{upgradeLink}。',
            upgradePlan: '升級套餐',
            limitExceeded: '使用次數已達上限，請升級套餐或明天再試。',
            limitExceededOverseas: '使用次數已達上限，請{upgradeLink}或明天再試。',
            limitExceededGuest: '使用次數已達上限，請註冊帳號或明天再試。',
            taskInProgress: '您有另一個任務正在執行中，請等待執行完畢後再提交。',
            globalTaskLimitExceeded: '當前系統負載過高，請稍後再試。',
            interruptFailed: '中斷請求失敗，請重試',
            contentFilter: '輸入內容包含敏感詞，請修改後重試。',
            emptyModelResponse: '模型未返回有效內容，請稍後重試。',
            modeChanged: '工作模式已切換',
            modeChangeFailed: '切換工作模式失敗',
            modeSwitchNotice: '已從 {from} 模式切換到 {to} 模式',
        },

        // 輸入框狀態條
        composerStatus: {
            idle: '等待輸入…',
            sending: '正在思考…',
            running: '正在執行…',
            runningWithEstimate: '正在執行，已運行 {elapsed}，預計約 {estimated}',
            runningWithElapsed: '正在執行，已運行 {elapsed}',
            runningLongTask: '正在處理多步驟撰寫任務',
            runningWithRemaining: '預計還需 {remaining}',
            runningFinalizing: '正在收尾…',
            runningMetaWithEstimate: '已運行 {elapsed} · 預估會隨進度更新',
            runningMetaWithElapsed: '已運行 {elapsed}',
            interrupting: '正在中斷…',
        },

        duration: {
            seconds: '{count} 秒',
            minutes: '{count} 分鐘',
            minutesSeconds: '{minutes} 分 {seconds} 秒',
        },

        browserNotification: {
            completedTabTitle: 'Hiro 任務已完成',
            failedTabTitle: 'Hiro 任務執行失敗',
            inputRequiredTabTitle: 'Hiro 等待你的輸入',
            completedTitle: 'Hiro 任務已完成',
            completedBody: '當前撰寫任務已完成，可以返回查看結果。',
            failedTitle: 'Hiro 任務執行失敗',
            failedBody: '當前撰寫任務未完成，請返回查看詳情。',
            inputRequiredTitle: 'Hiro 等待你的輸入',
            inputRequiredBody: '當前任務需要你的確認或補充資訊才能繼續。',
        },

        // Agent 類型名稱
        agentTypes: {
            disclosure: '技術交底書',
            prosecution: '答覆審查意見',
            express_prosecution: '極速答覆審查意見',
            patent_draft: '專利撰寫',
            unknown: '該功能',
        },

        // 指令相關
        instructions: {
            select: '選擇指令',
            refresh: '刷新指令列表',
            searchPlaceholder: '搜索指令...',
            noResults: '未找到相關指令',
            suggestionsTitle: '推薦指令',
            useThis: '使用此指令',
            navigate: '前往指令中心',
            instructionContent: '指令內容',
            description: '描述',
            tags: '標籤',
            jurisdiction: '適用地區',
            createdAt: '創建時間',
            exampleOutput: '示例輸出',
            close: '關閉',
        },

        // Pending 狀態
        pending: {
            title: '需要你的輸入',
            subtitle: 'Hiro 需要更多信息才能繼續',
            inputLabel: '你的回答',
            waitingInfo: '等待你的確認或輸入',
            tools: {
                askUser: '詢問用戶',
                task: '任務確認',
                todoWrite: '待辦事項',
            },
        },

        // 決策表單
        decisionForm: {
            multiSelectHint: '(可多選)',
            inputPlaceholder: '請輸入...',
            questionAdditionalPlaceholder: '如有補充說明，請在此輸入...',
            additionalAnswerLabel: '補充',
            submitted: '已提交',
            submit: '提交',
            cancel: '取消',
            loading: '載入決策表單...',
            parseError: '⚠️ 決策表單數據格式錯誤',
            upload: {
                button: '上傳檔案',
                uploading: '上傳中...',
                remove: '移除 {fileName}',
                failed: '上傳失敗，請重試',
                unsupportedType: '不支援的檔案格式',
                tooLarge: '檔案超過 50MB',
            },
        },

        // 指令表單
        instructionForm: {
            kicker: '指令表單',
            fieldCount: '{count} 個字段',
            instructionContent: '指令內容',
            instructionContentPlaceholder: '可編輯本次要發送給 AI 的指令內容',
            inputPlaceholder: '請輸入...',
            selectPlaceholder: '請選擇',
            extraRequirement: '補充要求',
            extraRequirementPlaceholder: '可補充本次使用該指令時需要 AI 注意的信息',
            extraRequirementInline: '補充具體要求',
            directRun: '直接執行',
            charCount: '{count} 字',
            recognizedInstruction: '識別到「{name}」預設指令',
            detail: '詳情',
            requiredError: '請填寫「{label}」',
            emptyValue: '未填寫',
            submit: '提交',
            submitted: '已提交',
            cancel: '取消',
            cancelled: '已取消',
            parseError: '指令表單數據格式錯誤',
            yes: '是',
            no: '否',
            outputInstructionName: '指令名稱',
            outputInstructionDescription: '指令描述',
            outputInstructionContent: '指令內容',
            outputUserInputs: '補充要求',
            outputFieldDescription: '字段說明',
            outputUserAnswer: '補充要求',
            optionSourceClaims: '權利要求',
            optionSourceFigures: '附圖',
            optionSourceSelect: '選擇{source}',
            optionSourceReselect: '重新選擇{source}（已選 {count}）',
            optionSourceTitle: '選擇{source}',
            optionSourceHint: '從當前文檔中解析可選內容，選擇後會作為補充要求發送給 AI。',
            optionSourceRefresh: '重新解析',
            optionSourceLoading: '正在解析文檔內容...',
            optionSourceEmpty: '未識別到{source}',
            optionSourceNoDocument: '未找到可解析的文檔內容',
            optionSourceFailed: '解析失敗',
            optionSourceRetry: '重試',
            optionSourceConfirm: '確認選擇',
        },

        // 模板章節表單
        templateSectionForm: {
            kicker: '模板章節表單',
            sourceTemplate: '來源模板：{name}',
            sectionPrompt: '章節指令內容',
            sectionPromptPlaceholder: '可編輯本次要發送給 AI 的章節指令內容',
            extraRequirementPlaceholder: '可補充本次生成該章節時需要 AI 注意的信息',
            recognizedSection: '識別到「{name}」章節指令',
            parseError: '模板章節表單數據格式錯誤',
            outputSectionPrompt: '章節指令內容',
            sectionNames: {
                TITLE: '發明名稱',
                BACKGROUND: '背景技術',
                SUMMARY_OF_INVENTION: '發明內容',
                BRIEF_DESCRIPTION_OF_FIGURES: '附圖說明',
                CLAIMS: '權利要求',
                ABSTRACT: '摘要',
                DETAILED_DESCRIPTION: '具體實施方式',
                DETAILED_DESCRIPTION_PLAN: '具體實施方式大綱',
                REPEAT_CLAIMS: '重複權利要求',
                CUSTOM: '自定義章節',
            },
        },

        templateSectionPopover: {
            title: '模板章節指令',
            close: '關閉',
            insert: '插入到左側文檔',
            apply: '應用',
            instruction: 'AI 指令',
            noInstruction: '未配置 AI 指令',
            fromLibrary: '從庫中選擇',
            remove: '刪除',
            addSection: '添加章節',
            newSection: '新章節',
            empty: '當前文檔沒有可用的模板章節',
            chars: '字符',
            fields: '字段',
        },

        // 任務建議
        suggestions: {
            title: '任務建議',
            agentLabels: {
                novelty: '專利查新智能體',
            },
        },

        // 引用內容
        reference: {
            label: '引用選中內容',
        },

        // 中斷提示
        interrupting: {
            title: '正在停止執行',
            description: '正在安全地終止當前任務...',
            interrupted_by_user: '執行已被用戶中斷',
            processing: '正在處理...',
        },

        // 錯誤信息
        error: {
            technicalDetails: '技術詳情（僅開發環境）',
            errorCode: '錯誤代碼：',
            permissionDeniedReadOnly: '當前為唯讀權限，無法發送消息',
            permissionDeniedEdit: '示例項目為唯讀，請{createLink}您自己的可編輯版本',
            createLink: '創建',
            permissionDeniedDelete: '當前權限不足，無法刪除',
            permissionDeniedNoAccess: '無權訪問此資源',
        },

        // 任務列表
        tasks: {
            completed: '已完成',
            markComplete: '標記為完成',
            collapse: '收起任務列表',
            expand: '展開查看全部任務',
        },

        // 工具相關
        relatedFiguresResult: {
            title: '本申請及對比文件附圖證據', application: '來源檔案', applicationDocument: '本申請', loadError: '無法讀取最新附圖證據，請稍後重試。',
            issueNavigation: '核駁問題列表', unnamedClaim: '未標明請求項', examinerReasoning: '審查員爭議', page: 'PDF 第 {page} 頁', officialImage: '官方圖頁',
            supportedFeature: '支持的爭議特徵', directObservation: '圖中直接可見', referenceSigns: '附圖標記', textualSupport: '說明書文字依據',
            noTextualSupport: '未提供文字依據，不應作為修改或答覆結論的決定性證據。', noEvidence: '已檢查本申請及引用對比文件，未發現可直接輔助本問題的附圖。',
            pendingEvidence: '此問題的附圖證據尚未完成抽取。', noIssues: '沒有可顯示的核駁問題。',
            imageLoading: '正在取得圖片...', imageUnavailable: '圖片暫時無法使用', imageRetry: '圖片載入失敗，重新取得', retry: '重試',
            evidenceBoundary: '按本申請、D1、D2等來源嚴格分開顯示；圖片不能單獨證明精確尺寸、隱藏連接、技術效果或法律結論。',
            strategyInvalidated: '附圖證據發生變化，{issues} 的舊策略已失效，需要重新分析。',
            status: { completed: '抽取完成', pending: '等待抽取', failed: '抽取失敗' },
            summary: { issues: '已檢查問題', officialImages: '已檢查官方圖頁', supportedIssues: '有直接圖證的問題', figures: '附圖證據', noDirectSupport: '無直接圖證的問題' },
            confidence: { high: '高置信度', medium: '中置信度', low: '低置信度' },
        },

        toolCall: {
            result: '查看工具結果',
            toolResultLabel: '工具結果',
            toolResultHint: '此為工具執行的中間結果，最終內容請以「文檔」中的版本為準',
            parameterDetails: '參數詳情',
            executing: '執行中...',
            expand: '展開詳情',
            collapse: '收起',
            betaBadge: 'Beta',
            spawnSteps: '{count} 個子步驟',
        },

        toolGroup: {
            title: '{title} 等 {count} 個步驟',
            stepCount: '{count} 個步驟',
            completedCount: '完成 {count}',
            runningCount: '執行中 {count}',
            failedCount: '失敗 {count}',
        },

        // 圖片預覽
        imagePreview: {
            generatedImage: 'AI 生成圖片',
            zoomIn: '放大',
            zoomOut: '縮小',
            download: '下載',
            close: '關閉',
        },

        // 附圖生成
        imageGeneration: {
            title: '附圖生成分析',
            promptLabel: '生成提示詞',
            imagePreview: '生成結果',
            noImage: '暫無生成圖片',
            failedTitle: '圖片生成失敗',
            timeoutError: '圖片生成逾時，請稍後重試。',
            genericError: '圖片生成失敗，請稍後重試。',
        },

        // 工具名稱
        tools: {
            unknown: '工具調用',
            timeUnknown: '--:--',
            // Skill Hub（Skill Agent）
            list_skills_for_agent: '技能列表',
            read_skill: '讀取技能',
            edit_skill_file: '編輯技能檔案',
            create_skill: '建立技能',
            update_skill: '更新技能',
            rename_or_delete_skill_file: '重新命名/刪除技能檔案',
            get_current_time: '獲取當前時間',
            create_document: '創建文檔',
            read_document: '讀取文檔',
            list_project_attachments: '列出項目附件',
            read_attachment_content: '讀取附件內容',
            read_image: '讀取圖片',
            auto_annotate_image: '自動標註圖片',
            intelligent_patent_search: '智能專利檢索',
            get_patent_details: '獲取專利詳情',
            paper_semantic_search: '論文語義檢索',
            web_search: '網絡搜索',
            patent_drafting_tool: '專利撰寫分析',
            // 專利撰寫動態顯示名：前綴 + 部分名（多於2個時折疊為「等N個部分」）
            draftingPrefix: '撰寫',
            draftingMore: '等{count}個部分',
            draftingSections: {
                Claims: '權利要求',
                Title: '發明名稱',
                Field: '技術領域',
                Background: '背景技術',
                Summary: '發明內容',
                Drawing_desc: '附圖說明',
                Description: '具體實施方式',
                Abstract: '摘要',
                Outline: '大綱',
            },
            patent_rule_review_tool: '專利規則審查',
            review_oar_response: '審查答覆文件核稿',
            extract_oa_and_generate_rejection_table: '提取審查意見並生成駁回分析表',
            extract_oa_analysis: '提取審查意見並生成駁回分析表',
            extract_oa_info: '提取審查意見',
            extract_raw_text: '提取原文內容',
            extract_related_figures: '提取相關附圖',
            analyze_oa_rejections: '生成審查意見答覆策略',
            generate_oa_strategy: '生成審查意見答覆策略',
            generate_oar_content: '生成OAR文檔',
            render_rejection_table: '展示駁回分析表',
            update_rejection_table: '更新駁回分析表',
            validate_oa_strategy: '驗證審查意見答覆策略',
            fetch_office_action_pdf: '獲取審查意見PDF',
            fetch_historical_files: '獲取歷史文件',
            analyze_disclosure: '分析技術交底書',
            novelty_creativity_evaluation: '新穎性創造性評估',
            update_plan: '更新計劃',
            read_style: '讀取撰寫風格',
            read_template: '讀取模板',
            request_user_decision: '請求用戶決策',
            load_skill: '加載技能',
            inject_agent_skill: '加載历史上下文',
            load_skill_content: '加載技能',
            detect_and_setup_patent_office: '檢測並設置專利受理局',
            write_document: '撰寫文檔',
            express_generate_reply: '生成答覆意見',
            check_express_eligibility: '檢查生成條件',
            suggest_next_step: '建議下一步',
            analyze_oa_response_strategy: '分析審查意見答覆策略',
            streaming: '工具輸出中...',
            done: '工具調用已完成',
            generate_oar_document: '生成審查意見答覆書',
            generate_image: '附圖生成分析',
            convert_patent_figure: '專利附圖生成',
            draw_patent_figures: '繪製專利附圖',
            label_patent_figures: '標註專利附圖',
            plan_patent_drawings: '規劃專利附圖方案',
            adjust_patent_analysis_step: '調整分析結果',
            mask_edit_figure: '局部修圖',
            spawn_agent: '技術探索',
        },

        // 新穎性創造性評估渲染器
        noveltyEvaluation: {
            tabPatents: '對比專利',
            tabEvaluations: '評估報告',
            noData: '暫無數據',
            parseError: '數據解析失敗',
        },

        // 專利搜索結果渲染器
        patentSearch: {
            found: '前{count}篇相關專利',
            searchResult: '搜索結果',
            expand: '展開',
            collapse: '收起',
            applicationDate: '申請日期',
            publicationDate: '公開日期',
            relevance: '相關度',
            parseError: '數據解析失敗',
            showDetails: '專利詳情',
            noData: '暫無數據',
            searchTypes: {
                semantic_search: '語義檢索',
                structured_query: '結構化檢索',
                patent_number: '專利號檢索',
            },
        },

        // 浮動視窗
        floating: {
            minimize: '最小化',
            maximize: '最大化/還原',
            close: '關閉',
        },

        // 專利詳情渲染器
        patentDetail: {
            basicInfo: '基本信息',
            patentNumber: '專利號',
            title: '標題',
            applicationNumber: '申請號',
            applicationDate: '申請日期',
            publicationDate: '公開日期',
            inventor: '發明人',
            applicant: '申請人',
            abstract: '摘要',
            copySection: '複製章節',
            copyAll: '複製全部',
            export: '導出',
            copySuccess: '已複製 {section}',
            copyFailed: '複製失敗',
            exportSuccess: '導出成功',
            exportFailed: '導出失敗',
            images: '附圖',
            parseError: '數據解析失敗',
            fallbackHint: '以下為原始內容：',
            textFormatError: '當前內容為文字格式，請在對話中查看完整內容。',
        },

        // 論文搜索結果渲染器
        paperSearch: {
            title: '論文語義檢索',
            found: '找到 {count} 篇相關論文',
            noData: '暫無相關論文',
            parseError: '數據解析失敗',
            showDetails: '查看詳情',
            authors: '作者',
            journal: '期刊',
            publishTime: '發表時間',
            doi: 'DOI',
            citationCount: '被引次數',
            downloadPdf: '下載 PDF',
            searchModes: {
                text: '文本語義檢索',
                paper: '相似論文檢索',
                patent: '專利關聯論文',
            },
        },

        // LLM 回放
        llmReplay: {
            title: '請求體',
            formView: '表單視圖',
            jsonView: 'JSON視圖',
            basicConfig: '基礎配置',
            model: '模型',
            modelPlaceholder: '例如: claude-4.6-sonnet',
            temperature: '溫度',
            maxTokens: '最大Token數',
            stream: '串流輸出',
            reasoningEffort: '推理強度',
            selectPlaceholder: '請選擇',
            messageList: '訊息列表',
            addMessage: '新增訊息',
            messageIndex: '訊息 {index}',
            delete: '刪除',
            role: '角色',
            rolePlaceholder: '請選擇角色',
            content: '內容',
            contentPlaceholder: '請輸入訊息內容',
            jsonPlaceholder: '請輸入JSON格式的請求體',
            jsonError: 'JSON格式錯誤: {message}',
            switchError: '無法切換: JSON格式錯誤',
            replayResult: '回放結果',
            fieldRole: '角色',
            fieldContent: '內容',
            finishReason: '完成原因',
            tokenUsage: 'Token 使用統計',
            promptTokens: '輸入 Tokens:',
            completionTokens: '輸出 Tokens:',
            totalTokens: '總計:',
            modelInfo: '模型資訊',
            modelLabel: '模型:',
            createdAt: '建立時間:',
            requestId: '請求 ID:',
            statusIdle: '未開始',
            statusReplaying: '回放中',
            statusSuccess: '成功',
            statusError: '失敗',
            preserveFieldsHint: '僅編輯原請求中已存在的基礎參數；其他欄位會原樣保留。',
            addUserMessage: '新增 User 訊息',
            newUserMessage: '新增 User 訊息',
            userMessagePlaceholder: '輸入下一輪訊息，支援 Markdown',
            addToConversation: '加入對話',
            emptyConversation: '目前請求中沒有訊息，可從下方新增 User 訊息。',
            edit: '編輯',
            save: '儲存',
            cancel: '取消',
            messageJsonError: '訊息必須是包含 role 欄位的 JSON 物件',
            additionalFields: '附加欄位',
            rawMessage: '完整訊息 JSON',
            toolDefinitions: '工具定義',
            addTool: '新增工具',
            rawToolDefinition: '完整工具定義 JSON',
            otherParameters: '其他請求參數',
            editOtherInJson: '這些欄位會原樣傳送；如需修改，請切換到 JSON 視圖。',
            requestMustBeObject: '請求體必須是 JSON 物件',
            reasoningContent: '推理內容',
            returnedToolCalls: '模型返回的工具呼叫',
            invalidToolArguments: 'Arguments 不是有效 JSON，以下保留原始字串。',
            simulatedToolResult: '模擬 Tool 返回值',
            simulatedToolResultPlaceholder: '輸入該工具呼叫的返回內容',
            rawToolCall: '完整 Tool Call JSON',
            messagesAdded: '訊息已加入請求上下文',
            addToolCallAndResults: '新增工具呼叫及返回值',
            addAssistantMessage: '新增 Assistant 訊息',
            completeToolResultsHint: '填寫所有工具返回值後才能新增。',
            effectiveRequest: '實際傳送請求',
            viewEffectiveRequest: '查看實際請求體',
            rawResponse: '完整原始響應',
            unrecognizedResponse: '無法識別響應結構，請查看完整原始響應。',
            validationFailed: '訊息協議校驗未通過',
        },
    },
};
